// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-shypcx-scjtShypcx-index-main_right_content-22h8Z","table":"components-tjcx-shypcx-scjtShypcx-index-table-7QUvu"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/shypcx/scjtShypcx/index.css
// module id = 2315
// module chunks = 0